module.exports = __webpack_public_path__ + "assets/img/pl.094cb9df.png";